import { ComputedStaticTextInput } from '@framework/form';
import { useCallback } from 'react';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import type { IComputedNumberWidget } from '../IComputedWidget';
import { formatComputedNumberValue } from './computedNumberFormatter';
import { useNumberExpressionValue } from './useNumberExpressionValue';

export interface IComputedNumberWidgetComponentProps
  extends IWidgetComponentProps<IComputedNumberWidget> {}

export function ComputedNumberWidgetComponent(
  props: IComputedNumberWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const value = useNumberExpressionValue(options.name, widget.expression);

  const formatValue = useCallback(
    (value: number | null) => formatComputedNumberValue(value),
    [],
  );

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <ComputedStaticTextInput
        name={options.name}
        value={value}
        removeBorder={widget.layout?.removeBorder}
        format={formatValue}
        readonly={options.readonly}
      />
    </ConfigFormItem>
  );
}
